import { Data, TransformsList } from 'cio/utils/analytics/transforms';
import { generateSource } from 'cio/utils/analytics/sources';
import { Platform, PushProvider } from 'cio/utils/push/platforms';

export const PlatformNames = {
  android: 'Android',
  ios: 'iOS',
};

type AuthorizationArgs = {
  platform: Platform;
  provider: PushProvider;
};

const Transforms: TransformsList = {
  setupView(data: Data & { platform: Platform }) {
    return {
      Platform: PlatformNames[data.platform],
      Source: generateSource(data),
    };
  },

  setupChecklistView(data: Data & { platform: Platform }) {
    return { Platform: PlatformNames[data.platform] };
  },

  messageSettingsViewed(data) {
    return {
      'Android Push Status': data.android ? 'Enabled' : 'Disabled',
      'iOS Push Status': data.ios ? 'Enabled' : 'Disabled',
    };
  },

  configurationViewed(data: Data & { platform: Platform }) {
    return {
      platform: PlatformNames[data.platform],
      Source: generateSource(data),
    };
  },
  autorizationAdded(data: Data & AuthorizationArgs) {
    return {
      platform: PlatformNames[data.platform],
      provider: data.provider?.toUpperCase(),
    };
  },

  autorizationUpdated(data: Data & AuthorizationArgs) {
    return {
      platform: PlatformNames[data.platform],
      provider: data.provider?.toUpperCase(),
    };
  },

  pushDisabled(data: Data & AuthorizationArgs) {
    return {
      platform: PlatformNames[data.platform],
      provider: data.provider?.toUpperCase(),
    };
  },
};

export default Transforms;
